module.exports = __webpack_public_path__ + "static/media/IMG_0064-2.2a2e9315.jpg";